import gql from 'graphql-tag';
import {
  AddressComponent,
  AuditCheckboxComponent,
  AuditTagComponent,
  AuditTextComponent,
  CombinedTagsComponent,
  DateComponent,
  DateRangeComponent,
  EmailComponent,
  EntityBatchComponent,
  FileComponent,
  GeolocationComponent,
  InputButtonComponent,
  NumberComponent,
  PersonComponent,
  ReferencedInComponent,
  RelatedCardComponent,
  RelatedCardLookupComponent,
  ScheduledAutomationComponent,
  SignatureComponent,
  StaticTextComponent,
  SubformComponent,
  SubtableComponent,
  TagComponent,
  TextComponent,
  TimeTrackerComponent,
  TodoComponent,
  UrlComponent,
} from './component';

export const WorkflowTemplate = gql`
  fragment WorkflowTemplate on WorkflowTemplate {
    id
    businessId
    createdAt
    updatedAt
    userId
    name
    parentId
    referencingTitleComponentId
    isSubform
    type
    viewTemplateDefaults {
      create
      update
    }
    channelDefaultConfiguration {
      imageUrl
    }
    behavior {
      onNewCard {
        type
        selectors {
          viewTemplateId
          selector
        }
      }
      onOpenCard {
        type
        selectors {
          viewTemplateId
          selector
        }
      }
    }
    components {
      ...AddressComponent
      ...AuditCheckboxComponent
      ...AuditTagComponent
      ...AuditTextComponent
      ...CombinedTagsComponent
      ...DateComponent
      ...DateRangeComponent
      ...EmailComponent
      ...EntityBatchComponent
      ...FileComponent
      ...GeolocationComponent
      ...NumberComponent
      ...PersonComponent
      ...RelatedCardComponent
      ...RelatedCardLookupComponent
      ...ScheduledAutomationComponent
      ...SignatureComponent
      ...StaticTextComponent
      ...SubformComponent
      ...SubtableComponent
      ...TagComponent
      ...TextComponent
      ...TodoComponent
      ...InputButtonComponent
      ...TimeTrackerComponent
      ...ReferencedInComponent
      ...UrlComponent
    }
    archivedComponents {
      ...AddressComponent
      ...AuditCheckboxComponent
      ...AuditTagComponent
      ...AuditTextComponent
      ...CombinedTagsComponent
      ...DateComponent
      ...DateRangeComponent
      ...EmailComponent
      ...EntityBatchComponent
      ...FileComponent
      ...GeolocationComponent
      ...NumberComponent
      ...PersonComponent
      ...RelatedCardComponent
      ...RelatedCardLookupComponent
      ...ScheduledAutomationComponent
      ...SignatureComponent
      ...StaticTextComponent
      ...SubformComponent
      ...SubtableComponent
      ...TagComponent
      ...TextComponent
      ...TodoComponent
      ...InputButtonComponent
      ...TimeTrackerComponent
      ...ReferencedInComponent
      ...UrlComponent
    }
  }
  ${AddressComponent}
  ${AuditCheckboxComponent}
  ${AuditTagComponent}
  ${AuditTextComponent}
  ${CombinedTagsComponent}
  ${DateComponent}
  ${DateRangeComponent}
  ${EmailComponent}
  ${EntityBatchComponent}
  ${FileComponent}
  ${GeolocationComponent}
  ${NumberComponent}
  ${PersonComponent}
  ${RelatedCardComponent}
  ${RelatedCardLookupComponent}
  ${ScheduledAutomationComponent}
  ${SignatureComponent}
  ${StaticTextComponent}
  ${SubformComponent}
  ${SubtableComponent}
  ${TagComponent}
  ${TextComponent}
  ${TodoComponent}
  ${InputButtonComponent}
  ${TimeTrackerComponent}
  ${ReferencedInComponent}
  ${UrlComponent}
`;

export const WorkflowEntity = gql`
  fragment WorkflowEntity on WorkflowEntity {
    id
    workflowTemplateId
    createdAt
    updatedAt
    fields
    threadId
    channelId
  }
`;
